import { IModalsConfig } from './../modals.config.interface';

export const ADD_CAREER_MODAL_CONFIG: IModalsConfig = {
  input: { placeholder: 'Enter a career...' },
  buttons: {
    confirm: { text: 'Add', disableButtonRipple: true },
    cancel: { text: 'Cancel', disableButtonRipple: true },
  },
};
